import { render, staticRenderFns } from "./EMLayoutAdapter.vue?vue&type=template&id=04bcc679&scoped=true&"
import script from "./EMLayoutAdapter.vue?vue&type=script&lang=js&"
export * from "./EMLayoutAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcc679",
  null
  
)

export default component.exports